(function () {
    'use strict';

    angular
        .module('wsl.core')
        .directive('wsl-closeByClickOut', closeByClickOut);

    closeByClickOut.$inject = ['$document'];

    /* @ngInject */
    function closeByClickOut($document) {
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            function onClick(event) {
                var isChild = angular.element(element).find(event.target);
                var isSelf = element[0] == event.target;
                var isRemoved = !angular.element($document).find(event.target);
                var isInside = isChild || isSelf || isRemoved;
                if (!isInside) {
                    scope.$apply(attrs.closeByClickOut)
                }
            }
            scope.$watch(attrs.isActive, function(newValue, oldValue) {
                if (newValue == true) {
                    $document.bind('click', onClick);
                }
                else if (newValue == false) {
                    $document.unbind('click', onClick);
                }
            });

            scope.$on('$destroy', function() {
                $document.unbind('click', onClick);
            });
        }
    }
})();
